export default {
  speciality: [
    {
      "code": "02.00.01",
      "name": "Неорганическая химия "
    },
    {
      "code": "02.00.02",
      "name": "Аналитическая химия"
    },
    {
      "code": "02.00.03",
      "name": "Органическая химия"
    },
    {
      "code": "02.00.03",
      "name": "Органическая химия"
    },
    {
      "code": "02.00.04",
      "name": "Физическая химия"
    },
    {
      "code": "02.00.04",
      "name": "Физическая химия"
    },
    {
      "code": "02.00.05",
      "name": "Электрохимия"
    },
    {
      "code": "02.00.06",
      "name": "Высокомолекулярные соединения"
    },
    {
      "code": "02.00.08",
      "name": "Химия элементоорганических соединений"
    },
    {
      "code": "02.00.09",
      "name": "Химия высоких энергий"
    },
    {
      "code": "02.00.10",
      "name": "Биоорганическая химия"
    },
    {
      "code": "02.00.11",
      "name": "Коллоидная химия"
    },
    {
      "code": "02.00.11",
      "name": "Коллоидная химия"
    },
    {
      "code": "02.00.13",
      "name": "Нефтехимия"
    },
    {
      "code": "02.00.14",
      "name": "Радиохимия"
    },
    {
      "code": "02.00.15",
      "name": "Кинетика и катализ"
    },
    {
      "code": "02.00.16",
      "name": "Медицинская химия"
    },
    {
      "code": "02.00.17",
      "name": "Математическая и квантовая химия"
    },
    {
      "code": "02.00.21",
      "name": "Химия твердого тела"
    },
    {
      "code": "03.01.06",
      "name": "Биотехнология ( в том числе бионанотехнологии)"
    },
    {
      "code": "03.02.08",
      "name": "Экология (по отраслям)"
    },
    {
      "code": "05.02.22",
      "name": "Организация производства (по отраслям)"
    },
    {
      "code": "05.13.01",
      "name": "Системный анализ"
    },
    {
      "code": "05.13.06",
      "name": "Автоматизация и управление технологическими процессами и производствами (по отраслям)"
    },
    {
      "code": "05.13.18",
      "name": "Математическое моделирование"
    },
    {
      "code": "05.16.08",
      "name": "Нанотехнологии и наноматериалы (по отраслям)"
    },
    {
      "code": "05.16.09",
      "name": "Материаловедение"
    },
    {
      "code": "05.17.01",
      "name": "Технология неорганических веществ"
    },
    {
      "code": "05.17.02",
      "name": "Технология редких и рассеянных радиоактивных эелементов"
    },
    {
      "code": "05.17.03",
      "name": "Технология электрохимических процессов и защита от коррозии"
    },
    {
      "code": "05.17.04",
      "name": "Технология органических веществ"
    },
    {
      "code": "05.17.06",
      "name": "Технология и переработка полимеров и композитов"
    },
    {
      "code": "05.17.07",
      "name": "Химическая технология топлива и высокоэнергетических веществ"
    },
    {
      "code": "05.17.08",
      "name": "Процессы и аппараты химических технологий"
    },
    {
      "code": "05.17.11",
      "name": "Технология силикатных и тугоплавких неметаллических материалов"
    },
    {
      "code": "05.17.18",
      "name": "Мембраны и мембранные технологии"
    },
    {
      "code": "05.26.03",
      "name": "Пожарная и промышленная безопасность (по отраслям)"
    },
    {
      "code": "05.27.06",
      "name": "Технология и оборудование для производства полупроводников"
    },

  ],
  branch: [
    'Химические науки',
    'Биологические науки',
    'Технические науки'
  ]
};
